import type { FaireProductEntity } from "../../entity_types/product";

export const p_5u6wy9p835: FaireProductEntity = {
  token: "p_5u6wy9p835",
  type: "product",
  name: "Plush Vetiver– HI-FI Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/bb808f7de40533005795795cb776cf813f2275e186cc05265036f9011912d4a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de30ad783198a04dde273883510b961447ea08b28155829c9d75e1e22ea0aa3d.jpeg",
    "https://cdn.faire.com/fastly/2e4ca8d673a9f6311fa03551a5d99d91a43508c80e9611819c45e85107a88dee.jpeg",
    "https://cdn.faire.com/fastly/e4ef77169b9dcd818f35b3fc8a0198635d0be7b4ffbae33e16e77f6885694189.jpeg",
    "https://cdn.faire.com/fastly/1d4c652c25091f0ee09a954f9e194a92e0e741d8eb4e3e6a5003bfcb7a3567ea.jpeg",
    "https://cdn.faire.com/fastly/4360c47c9a100dc14def27d13cb1bb6b47f16e2df06b90b3d1ae16730de62f71.jpeg",
  ],
  priceDollars: 21.5,
  description:
    "*RESTOCKING IN SUMMER 2026*\n\n\nPlush velvet and smooth banquettes in a dimly lit cocktail lounge. Musky, earthy, and soft with a velvety floral undertone.  Haitian vetiver, velvet iris, patchouli leaf, and beetroot.\n\nPRODUCT INFORMATION: \n\nOur 13 oz Double Wick Hi-Fi Candles are hand-poured into premium cocoa brown vessels with a vermilion debossed label, and packaged in a premium paper gift box.\n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for up to 60 hours.",
  tags: [],
  msrpDollars: 43.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:54.936Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
